
import { TilesType } from 'types/src/types';
import { Icon } from './Icon';
import { TooltipComponent } from '../layout';

export const AddImageIcon = () => {
  return (
    <div className="flex items-center justify-center px-[9.5px] py-3 border-1 bg-bg-gray rounded-sm">
      <Icon
        name="imageView"
        width={17}
        height={13}
        className="bg-transparent text-black"
      />
    </div>
  );
};

type Props = {
  onClick: (type: TilesType) => void;
};

export const AddImageIconSm = ({ onClick }: Props) => {
  return (
    <TooltipComponent
      text="Add Image"
      className="bg-black text-white w-fit"
    >
      <button
        className="border-1 border-black/5 bg-white rounded-[8px] overflow-hidden size-8 custom-shadow hover:bg-bg-gray transition-all ease-in-out duration-300 flex items-center justify-center"
        onClick={() => onClick('add-image')}
      >
        <Icon
          name="imageView"
          width={17}
          height={13}
          className="bg-transparent text-black"
        />
      </button>
    </TooltipComponent>
  );
};
